import { useState } from "react";
import styles from './WorkSelection.module.scss';
import PageLoader from "@features/common/pageLoader/PageLoader";
import UserDropDown from "../userDropDown/UserDropDown";

export const WorkSelection = ({
  isWorkTabActive,
  isUserSignedIn,
}: {
  isWorkTabActive: boolean;
  isUserSignedIn: boolean;
  handleWorkTabSelection?: () => void;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className={`${styles["tab-selection-wrap"]}`}>
      {isLoading && <PageLoader />}
      <div>
        <div
          className={
            isWorkTabActive
              ? `${styles["tab-selection-work"]} ${styles["tab-selection-work--active"]}`
              : styles["tab-selection-work"]
          }
        >
          <div
            className={`${styles["tab-selection-work__extension"]} ${styles["tab-selection-work__extension--right"]}`}
          />
          <img
            src={"/images/atwork-pro-logo.svg"}
            alt="AtWork Pro Logo"
            className={`${isUserSignedIn ? "adjust-margin-util" : ""}`}
          />
          {isWorkTabActive && (
            <div
              className={`${styles["tab-selection-work__extension"]} ${styles["tab-selection-work__extension--left"]}`}
            />
          )}
          <div>
            <UserDropDown />
          </div>
        </div>
      </div>
    </div>
  );
};
